import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useEditOrderContext } from '../contexts/EditOrderContext';

interface SetOnHoldButtonProps {
  waterCompanyName: string;
  onPlacedOnHoldCompleted?: (comment: string) => Promise<void>;
}

export const SetOnHoldButton: React.FC<SetOnHoldButtonProps> = ({ waterCompanyName, onPlacedOnHoldCompleted }) => {
  const commentText = `Awaiting Third Party Data (${waterCompanyName})`;
  const { isEditable } = useEditOrderContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = async () => {
    try {
      setIsSubmitting(true);
      await onPlacedOnHoldCompleted?.(commentText);
    } catch (error) {
      console.error('Failed to set order on hold:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      disabled={!waterCompanyName || isSubmitting || !isEditable}
      sx={{
        textTransform: 'none',
        backgroundColor: waterCompanyName ? '#008E9C' : '#cccccc',
        borderRadius: 0,
        maxHeight: 32,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:not(:disabled):hover': {
          backgroundColor: waterCompanyName ? '#01707a' : '#cccccc'
        },
        '&.Mui-disabled': {
          backgroundColor: '#cccccc',
          color: '#ffffff',
          opacity: 0.7,
          cursor: 'not-allowed'
        },
        '&::after': {
          boxShadow: 'none !important'
        }
      }}
    >
      {isSubmitting ? 'Updating...' : 'Place on hold'}
    </Button>
  );
};
